import * as discoverRoutines from './discoverRoutines';
import produce from 'immer';

const initialState = {
    other: {},
    top: {},
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case discoverRoutines.syncDiscover.SUCCESS:
            return produce(state, draft => {
                draft.top = action.payload ? action.payload.top : {};
                draft.other = action.payload ? action.payload.other : {};
                draft.topCommonBackgroundImageURL = action.payload ? action.payload.topCommonBackgroundImageURL : {};
            });

        default:
            return state;
    }
}
